export default {
    getRequestError(state){
      return state.request_error;
    },
    getCustomers(state) {
      return state.customers_of_search;
    },
  };